import React from 'react';
import { ClipboardListIcon, FileTextIcon, NetworkIcon, CalendarCheckIcon, SearchIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { steps } from '../data/content';
const icons = [ClipboardListIcon, NetworkIcon, SearchIcon, CalendarCheckIcon, FileTextIcon];
export function DecisionMap() {
  return <section className="w-full bg-navy-900 px-5 py-16 text-white md:px-8 md:py-24" data-id="element-116" data-mp="2exnjhtw3fn39">
      <div className="mx-auto max-w-4xl" data-id="element-117" data-mp="2a05h6mcl0648">
        <p className="text-center font-serif text-lg font-bold text-gold-300" data-id="element-118" data-mp="2a0x4l9w0yxjf">Introducing the</p>
        <h2 className="mt-2 text-center font-serif text-[2rem] font-extrabold leading-tight sm:text-5xl" data-id="element-119" data-mp="256auda1ojb0x">
          Veneer Complication <span className="text-gold-400" data-id="element-120" data-mp="1vahi7rrvhjjo">Decision Map™</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-navy-100" data-id="element-121" data-mp="1v8d30doiwy43">
          A 5-step clinical framework for organizing veneer complication cases. It connects
          assessment, complication classification, clinical decision considerations, corrective
          planning, and documentation into one practical workflow.
        </p>

        <ol className="relative mt-12 space-y-6" data-id="element-122" data-mp="2sae0lo8y0uto">
          {steps.map((step, i) => {
          const Icon = icons[i];
          return <li key={step.name} className="relative flex gap-4 sm:gap-6" data-id="element-123" data-mp="2ijsy3pq5f65h" data-mpi={i}>
                <div className="flex flex-col items-center" data-id="element-124" data-mp="2ihq9na4n9l2v">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gold-400 text-navy-900 shadow-lg" data-id="element-125" data-mp="36agj9cp2rs9z">
                    <Icon className="h-7 w-7" aria-hidden="true" data-id="element-126" data-mp="3b6dwha51kiij" />
                  </span>
                  {i < steps.length - 1 && <span className="mt-2 w-0.5 flex-1 bg-gold-500/40" aria-hidden="true" data-id="element-127" data-mp="327s82ycw299u" />}
                </div>
                <div className="flex-1 rounded-2xl bg-navy-800 p-5 ring-1 ring-white/10 sm:p-7" data-id="element-128" data-mp="1lttnlpqftxk9">
                  <p className="text-sm font-extrabold uppercase tracking-wider text-gold-300" data-id="element-129" data-mp="1qsddu2c2dvif">
                    Step {i + 1} — {step.name}
                  </p>
                  <h3 className="mt-2 font-serif text-xl font-bold leading-snug sm:text-2xl" data-id="element-130" data-mp="3sjx06qm1vpky">{step.title}</h3>
                  <p className="mt-3 text-base leading-relaxed text-navy-100" data-id="element-131" data-mp="3nl28ez63uqop">{step.text}</p>
                  {step.list.length > 0 && <ul className="mt-3 space-y-1.5" data-id="element-132" data-mp="3er7e6m6iuknu">
                      {step.list.map(l => <li key={l} className="flex gap-2 text-base text-white" data-id="element-133" data-mp="39rkym6380sbv">
                          <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-400" aria-hidden="true" data-id="element-134" data-mp="34rovsa69f6xw" />
                          {l}
                        </li>)}
                    </ul>}
                  {step.note && <p className="mt-3 text-sm italic text-gold-200" data-id="element-135" data-mp="2vtczbrippexj">{step.note}</p>}
                  <div className="mt-4 rounded-xl bg-navy-950/60 px-4 py-3 text-sm" data-id="element-136" data-mp="y18mm2w4ywux">
                    <span className="font-bold text-gold-300" data-id="element-137" data-mp="u185ublke9kp">Practical output: </span>
                    <span className="text-white" data-id="element-138" data-mp="2bylcf2q958im">{step.output}.</span>
                  </div>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-12 text-center font-serif text-2xl font-bold text-gold-300 sm:text-3xl" data-id="element-139" data-mp="2lnlh92rfqy4q">
          Five stages. One repeatable workflow.
        </p>

        <SectionCTA dark label="Get Instant Access to the 5-Step Decision Map" data-id="element-140" data-mp="2pooqh6ez9vwz" />
      </div>
    </section>;
}